import React, { FC } from "react";
import { useIntl } from "react-intl";
import LockIcon from "@mui/icons-material/Lock";
import Box from "../Box";
import Typography from "../Typography";
import messages from "./messages";

// Pillar E1 — 'pending' fully replaces the drawer's normal content (Customer
// or Patient), so it takes over the full drawer regardless of which screen
// opened it.
const RecordLockedState: FC = () => {
  const { formatMessage } = useIntl();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        gap: 5,
      }}
    >
      <LockIcon sx={{ fontSize: 60 }} color="primary" />
      <Typography variant="body1" textAlign="center">
        {formatMessage(messages.pendingMessage)}
      </Typography>
    </Box>
  );
};

export default RecordLockedState;
